import { AttachmentType } from "./attachment-type";
import { MediaType } from "./media-type";

export interface ContactCard {
    contactId: number;
    caseId?: string;
    media: MediaType.VOICE | MediaType.DIGITAL | MediaType.VOICEMAIL;
    isOutbound?: boolean;
    isSelected: boolean;
    contactMode: string;
    customerName?: string;
    contactStatus: string;
    skillOrQueueId?: string;
    skillOrQueueName: string;
    channelName?: string;
    contactReceivedTime: string;
    showBadge?: boolean;
    isDocked?: boolean;
    callType?:string
    interactionId?: string;
    refusalTimeOut?: number;
    attachments?: Array<AttachmentType>;
    isContactRejected?: boolean;
    expandedViewDetails?: boolean;
    isContactAccepted?: boolean;
    customerCardUrl?:string;
}